
export const sortFoldersAlphabetically = (folders) => {
    if (!Array.isArray(folders)) {
        return [];
    }

    return [...folders].sort((a, b) => {
        const labelA = a.label || '';
        const labelB = b.label || '';

        const startsWithNumberA = /^\d/.test(labelA);
        const startsWithNumberB = /^\d/.test(labelB);

        if (startsWithNumberA && !startsWithNumberB) {
            return -1;
        }

        if (!startsWithNumberA && startsWithNumberB) {
            return 1;
        }

        return labelA.localeCompare(labelB, undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    });
}